import { render, staticRenderFns } from "./header-mask.vue?vue&type=template&id=56dff6e0&"
import script from "./header-mask.vue?vue&type=script&lang=js&"
export * from "./header-mask.vue?vue&type=script&lang=js&"
import style0 from "./header-mask.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./header-mask.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports